const state = {
  token: sessionStorage.getItem('token'),
  role:Number(sessionStorage.getItem('role')),
  newrouter:[],
  permissions:null
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js